var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9 13.5C15.3 13.35 14.7 13.05 14.25 12.6C13.8 12.45 13.65 12 13.65 11.7C13.65 11.4 13.8 10.95 14.1 10.8C14.55 10.5 15 10.2 15.45 10.35C16.35 10.35 17.1 10.8 17.55 11.4L18.9 9.6C18.45 9.15 18 8.85 17.55 8.55C17.1 8.25 16.5 8.1 15.9 8.1V6H14.1V8.1C13.35 8.25 12.6 8.7 12 9.3C11.4 10.05 10.95 10.95 11.1 11.85C11.1 12.75 11.4 13.65 12 14.25C12.75 15 13.8 15.45 14.7 15.9C15.15 16.05 15.75 16.35 16.2 16.65C16.5 16.95 16.65 17.4 16.65 17.85C16.65 18.3 16.5 18.75 16.2 19.2C15.75 19.65 15.15 19.8 14.7 19.8C14.1 19.8 13.35 19.65 12.9 19.2C12.45 18.9 12 18.45 11.7 18L10.2 19.65C10.65 20.25 11.1 20.7 11.7 21.15C12.45 21.6 13.35 22.05 14.25 22.05V24H15.9V21.75C16.8 21.6 17.55 21.15 18.15 20.55C18.9 19.8 19.35 18.6 19.35 17.55C19.35 16.65 19.05 15.6 18.3 15C17.55 14.25 16.8 13.8 15.9 13.5ZM15 3C8.4 3 3 8.4 3 15C3 21.6 8.4 27 15 27C21.6 27 27 21.6 27 15C27 8.4 21.6 3 15 3ZM15 25.35C9.3 25.35 4.65 20.7 4.65 15C4.65 9.3 9.3 4.65 15 4.65C20.7 4.65 25.35 9.3 25.35 15C25.35 20.7 20.7 25.35 15 25.35Z",
    fill: "#004A2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDollar);
export default __webpack_public_path__ + "static/media/IconDollar.492eb8880f5279abcf84fdd696ee746b.svg";
export { ForwardRef as ReactComponent };